module.exports = __webpack_public_path__ + "img/2024big19.befd1782.png";